import { TenantDomainId } from '../../store/features/pageConfig';

export const ltw365Data = {
  terms: 'https://ltw365.com/tandcs/',
};

const LTW365_TENANTS = [
  TenantDomainId.LTW365,
  TenantDomainId.AIINFINANCE,
  TenantDomainId.AIINRETAIL,
  TenantDomainId.CIOSUMMIT,
  TenantDomainId.CDAOSUMMIT,
];

export function isLtw365Tenant(tenantId: TenantDomainId): boolean | undefined {
  return LTW365_TENANTS.includes(tenantId);
}
